import { APP_INITIALIZER, Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { SharedModule } from "./shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import { UserService } from "./services/user.service";
import { NgxSmartModalModule } from "ngx-smart-modal";
import { PickupRequestService } from "./services/pickup-request.service";
import { AuthService } from "./services/auth.service";
import { AuthInterceptor } from "./services/auth-interceptor";
import { CommonService } from "./services/common.service";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TabService } from "./services/tab-service.service";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { LanguageService } from "./services/language.service";
import { TeamService } from "./services/team.service";
import { ClubService } from "./services/club.service";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { PaymentService } from "./services/payment.service";
import { PlayerService } from "./services/player.service";

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function appInit(languageService: LanguageService, tabService: TabService) {
  return async () => {
    const lang: string = await languageService.initLanguageFromUrl();
    await tabService.initTabFromUrl();
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PopoverModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    NgxSmartModalModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [LanguageService, TabService],
      multi: true
    },
    UserService,
    PickupRequestService,
    AuthService,
    CommonService,
    TeamService,
    ClubService,
    provideNgxMask(),
    PaymentService,
    PlayerService,
    provideClientHydration()
  ],
  bootstrap: [
    AppComponent
  ],
})
export class AppModule {}
